import BiographyComponent from './BiographyComponent';

/**
 * @typedef {import("@prismicio/client").Content.BiographySlice} BiographySlice
 * @typedef {import("@prismicio/react").SliceComponentProps<BiographySlice>} BiographyProps
 * @param { BiographyProps }
 */
const Biography = ({ slice }) => (
  <section>
    <BiographyComponent slice={slice} />
  </section>
);

export default Biography;
